export default __webpack_public_path__ + "43ef1e2b60644a1cdd17c353cac1e4ad.svg";